export const StateKeys = {
  EMAIL_SUBSCRIPTIONS: 'emailSubscriptions',
  EMAIL_SUBSCRIPTION_GROUPS: 'emailSubscriptionGroups',
  FETCH_SUBSCRIPTIONS_REQUEST_STATE: 'fetchSubscriptionsRequestState',
  FETCH_SUBSCRIPTION_GROUPS_REQUEST_STATE: 'fetchSubscriptionGroupsRequestState'
};
export const SUBSCRIPTION_GROUPS_INITIAL_STATE = {
  preferencesGroups: [],
  userAccessibleGroups: []
};